<template>
  <div>
    <div class="container-fluid mt--7">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-4 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none"> Colunas </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">Colunas</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-5 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-coluna">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Coluna
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th style="text-align: left">Título</th>
                  <th>Colunista</th>
                  <th>Status</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-coluna
                    v-for="coluna in state.colunas"
                    :key="coluna.id"
                    :coluna="coluna"
                    @deletarColuna="deletarColuna"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import CorpoTabelaColuna from "../../components/CorpoTabelaColuna";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaColuna,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      colunas: [],
    });
    onMounted(() => {
      fetchColuna();
    });
    async function fetchColuna() {
      try {
        const { data } = await services.coluna.getAll({ token });
        state.colunas = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarColuna(id) {
      if (confirm("Deseja deletar esta coluna?")) {
        try {
          state.isLoading = true;
          const { data } = await services.coluna.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar coluna.");
          } else {
            fetchColuna();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarColuna,
    };
  },
};
</script>

<style scoped>
table {
  color: black;
}
.div_btn_coluna {
  text-align: right;
  padding-right: 30px;
}
.div_tabela {
  height: auto;
}
.div_btn_usuario {
  text-align: right;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>